import { defineComponent as _defineComponent } from 'vue'
import Modal from '@/components/Modal.vue';
import { useQuickbooksSetup } from '@/composables/useQuickbooksSetup';
import { useAuth } from '@/store/auth';
import { ref } from 'vue';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'account',
  setup(__props, { expose: __expose }) {
  __expose();

const showInfo = ref(false);
function setShowInfo( x: boolean){
    showInfo.value = x
}

const auth       = useAuth();
const router     = useRouter();
const loggingOut = ref(false);
const { waiting, message, doLinkQuickbooks, isLoading, isSetup, } = useQuickbooksSetup();

async function doLogout() {
    loggingOut.value = true;
    await auth.signOut();
    await router.push({name: 'login'});
    loggingOut.value = false;
}

async function doQuickbooks() {
    await doLinkQuickbooks();
}


const __returned__ = { showInfo, setShowInfo, auth, router, loggingOut, waiting, message, doLinkQuickbooks, isLoading, isSetup, doLogout, doQuickbooks, Modal, get useQuickbooksSetup() { return useQuickbooksSetup }, get useAuth() { return useAuth }, ref, get useRouter() { return useRouter } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})